import {
  CHECK_DATA_CONVERSATION_FAILURE,
  CHECK_DATA_CONVERSATION_REQUEST,
  CHECK_DATA_CONVERSATION_SUCCESS,
  CREATE_CONVERSATION_FAILURE,
  CREATE_CONVERSATION_REQUEST,
  CREATE_CONVERSATION_SUCCESS,
  GET_CONVERSATIONS_RECENT_FAILURE,
  GET_CONVERSATIONS_RECENT_REQUEST,
  GET_CONVERSATIONS_RECENT_SUCCESS,
  UPDATE_QUERY,
  CHANGE_AUDIENCE_TIMEFRAME_REQUEST,
  CLEAR_CONVERSATION_QUERY_REQUEST,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    isFetchingRecentConversations: false,
    data: [],
    timeframes: [
      {
        label: 'Custom',
        value: 'custom',
        id: 'custom',
      },
      {
        label: 'Last month',
        value: 'last_month',
        id: 'now-1month,now',
      },
      {
        label: 'Last 3 months',
        value: 'last_3_months',
        id: 'now-3month,now',
      },
      {
        label: 'Last 6 months',
        value: 'last_6_months',
        id: 'now-6month,now',
      },
      {
        label: 'Last year',
        value: 'last_year',
        id: 'now-1year,now',
      },
    ],
    error: false,
  };
};

const initialState = getInitialState();

const conversation = (state = initialState, action) => {
  const types = {
    [GET_CONVERSATIONS_RECENT_REQUEST]: () => ({
      ...state,
      isFetchingRecentConversations: true,
    }),
    [GET_CONVERSATIONS_RECENT_SUCCESS]: () => ({
      ...state,
      isFetchingRecentConversations: false,
      error: false,
      data: action.response,
    }),
    [GET_CONVERSATIONS_RECENT_FAILURE]: () => ({
      ...state,
      isFetchingRecentConversations: false,
      error: true,
    }),
    [CREATE_CONVERSATION_REQUEST]: () => ({
      ...state,
      isLoading: true,
      error: undefined,
      message: undefined,
    }),
    [CREATE_CONVERSATION_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
    }),
    [CREATE_CONVERSATION_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [CHECK_DATA_CONVERSATION_REQUEST]: () => ({
      ...state,
      isCheckingData: true,
      checkedData: false,
      error: undefined,
      message: undefined,
      mentions: undefined,
    }),
    [CHECK_DATA_CONVERSATION_SUCCESS]: () => ({
      ...state,
      error: false,
      message: action.message,
      mentions: action.mentions,
      checkedData: true,
      isCheckingData: false,
    }),
    [CHECK_DATA_CONVERSATION_FAILURE]: () => ({
      ...state,
      error: true,
      message: action.message,
      checkedData: false,
      mentions: undefined,
      isCheckingData: false,
    }),
    [UPDATE_QUERY]: () => ({
      ...state,
      checkedData: false,
      mentions: undefined,
      isCheckingData: false,
    }),
    [CHANGE_AUDIENCE_TIMEFRAME_REQUEST]: () => ({
      ...state,
      checkedData: false,
      mentions: undefined,
      isCheckingData: false,
    }),
    [CLEAR_CONVERSATION_QUERY_REQUEST]: () => ({
      ...state,
      checkedData: false,
      error: false,
      message: undefined,
      mentions: undefined,
      isCheckingData: false,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default conversation;
